import React, { RefObject, useCallback, useEffect, useState } from 'react';
// @ts-ignore
import { Button, Loader, NavigationBar, NavigationContent } from 'arag-ui-lib';
import { Form, Formik } from 'formik';
import StepsRouter from '../../routers/stepsRouter';
// @ts-ignore
import ReCAPTCHA from 'react-google-recaptcha';
import config from '../../utils/constants/config';
import questionProjections from '../../projections/question';
import style from './claimForm.module.scss';
import codes from '../../utils/constants/codes';
import { useAppSelector } from '../../hooks/hooks';
import useStateIfMounted from '../../hooks/useStateIfMounted';
import { CurrencySchema } from '../../actions';
import { useTranslation } from 'react-i18next';
import GENERAL_FUNCTIONS from '../../utils/functions/functions';

type Props = {
    tabs: any;
    activeTab: string | null;
    onNextPage: (values: { [x: string]: any[] }) => undefined;
    onPreviousPage: () => void;
    onSubmitForm: (values: any) => void;
    setCaptchaValue: any;
    captchaValue: string | null;
    recaptchaRef: RefObject<any>;
    fetchingQuestionGroupSteps: boolean;
    isDraftApplicationRequestFinished: boolean;
    questionGroupsStepsLoading: boolean;
    setQuestionGroupsStepsLoading: (b: boolean) => void;
    questionTypes: { id: string; code: string; name: string }[];
    handleCurrencySelectWrapper: (
        currency:
            | {
                  sign: string;
                  code: string;
                  position: string;
              }
            | undefined,
        values: any,
    ) => void;
    selectedCurrency:
        | {
              sign: string;
              code: string;
              position: string;
          }
        | undefined;
    currencyOptions?: CurrencySchema[] | null;
    onAutoSaveDraftClaim: (values: any, currentCurrency: null) => void;
    loadingQuestionGroupStep: boolean;
    prevFetchingQuestionGroupSteps: boolean | undefined;
};
const ClaimForm = (props: Props): JSX.Element => {
    const {
        tabs,
        activeTab,
        onNextPage,
        onPreviousPage,
        onSubmitForm,
        setCaptchaValue,
        captchaValue,
        recaptchaRef,
        fetchingQuestionGroupSteps,
        isDraftApplicationRequestFinished,
        questionGroupsStepsLoading,
        setQuestionGroupsStepsLoading,
    } = props;
    const isCaptchaEnabled = useAppSelector(
        state => state.applicationSettings.apiApplicationSettings.enableCaptcha,
    ) as boolean;
    const submittingClaim = useAppSelector(
        state => state.claimApplication.submitting,
    ) as boolean;
    const fetchingQuestions = useAppSelector(
        state => state.question.loading,
    ) as boolean;
    const claimFormAnswers = useAppSelector(
        state => state.answer.answer.answerFromGroupSteps,
    ) as any;
    const answerFromGroupSteps = useAppSelector(
        questionProjections.fitlerAnswersByQuestions(claimFormAnswers),
    );
    const [isLastTab, setIsLastTab] = useState<boolean>(false);
    //when user upload files disable buttons and handle loaders
    const [isUploadingFile, setUploadingfile] = useState(null);
    const [fileUploadingProgress, setFileUploadingProgress] = useStateIfMounted(
        [],
    );
    const [fileDownloadingProgress, setFileDownloadingProgress] =
        useState(null);
    const [isDownloadingFile, setDownloadingFile] = useState(null);
    const { t } = useTranslation();
    useEffect(() => {
        if (
            tabs &&
            tabs.length > 0 &&
            tabs.findIndex((tab: { key: string }) => tab.key === activeTab) ===
                tabs.length - 1
        ) {
            setIsLastTab(true);
            //  setLoading(false)
        } else {
            setIsLastTab(false);
        }
    }, [activeTab, tabs]);

    useEffect(() => {
        if (!isLastTab) {
            setCaptchaValue(null);
        }
    }, [isLastTab]);

    // be sure the loader is set to false, when tabs are active.
    useEffect(() => {
        setQuestionGroupsStepsLoading(false);
    }, [setQuestionGroupsStepsLoading, questionGroupsStepsLoading, tabs]);

    const handleCaptcha = async (value: string) => {
        setCaptchaValue(value);
    };
    const handleButtonClick = useCallback(() => {
        GENERAL_FUNCTIONS.validateRequiredDateInputs();
    }, []);

    const handleCaptchaExpire = () => {
        setCaptchaValue(null);
    };

    return (
        <div>
            {questionGroupsStepsLoading && fetchingQuestionGroupSteps ? (
                <Loader variant={'inline'} label={t('loading')} />
            ) : (
                <React.Fragment>
                    <NavigationBar
                        activeItemKey={activeTab}
                        navItems={
                            tabs && tabs.length > 0
                                ? tabs.map((tab: { key: string }) => ({
                                      ...tab,
                                      navItemTestId: `navItem_${tab.key}`,
                                  }))
                                : []
                        }
                        variant={'wizard'}
                        stepCounter
                    />
                    <NavigationContent className={'tab-content--custom'}>
                        <Formik
                            validateOnChange={true}
                            initialValues={answerFromGroupSteps}
                            onSubmit={
                                isLastTab
                                    ? values => onSubmitForm(values)
                                    : values => onNextPage(values)
                            }
                        >
                            <div>
                                {fetchingQuestions ? (
                                    <Loader
                                        variant="inline"
                                        label={t('loading')}
                                    />
                                ) : (
                                    <Form
                                        className="form-horizontal"
                                        autoComplete="off"
                                        autoCorrect="off"
                                        spellCheck="false"
                                    >
                                        <StepsRouter
                                            {...props}
                                            isUploadingFile={isUploadingFile}
                                            setUploadingfile={setUploadingfile}
                                            fileUploadingProgress={
                                                fileUploadingProgress
                                            }
                                            setFileUploadingProgress={
                                                setFileUploadingProgress
                                            }
                                            setFileDownloadingProgress={
                                                setFileDownloadingProgress
                                            }
                                            fileDownloadingProgress={
                                                fileDownloadingProgress
                                            }
                                            setDownloadingFile={
                                                setDownloadingFile
                                            }
                                            isDownloadingFile={
                                                isDownloadingFile
                                            }
                                        />
                                        {isLastTab && isCaptchaEnabled && (
                                            <div className={'row form-group'}>
                                                <div className={'col-sm-12'}>
                                                    <ReCAPTCHA
                                                        ref={recaptchaRef}
                                                        sitekey={
                                                            config.CAPTCHA_SITE_KEY
                                                        }
                                                        onChange={handleCaptcha}
                                                        onExpired={
                                                            handleCaptchaExpire
                                                        }
                                                    />
                                                </div>
                                            </div>
                                        )}
                                        <div className={style['claim-buttons']}>
                                            <div
                                                className={
                                                    style['claim-submit']
                                                }
                                            >
                                                <Button
                                                    variant="primary"
                                                    label={
                                                        isLastTab
                                                            ? t('submit')
                                                            : t('nextStep')
                                                    }
                                                    arrowDirection="right"
                                                    type="submit"
                                                    onClick={handleButtonClick}

                                                    disabled={
                                                        (isLastTab &&
                                                            isCaptchaEnabled &&
                                                            !captchaValue) ||
                                                        submittingClaim ||
                                                        (activeTab ===
                                                            codes.declarationGroupStep &&
                                                            !isDraftApplicationRequestFinished) ||
                                                        isUploadingFile ||
                                                        fileUploadingProgress.find(
                                                            (
                                                                item:
                                                                    | {
                                                                          progress: number;
                                                                      }
                                                                    | never,
                                                            ) =>
                                                                item?.progress <
                                                                100,
                                                        ) !== undefined
                                                    }
                                                />
                                                {submittingClaim && (
                                                    <Loader
                                                        variant="inline"
                                                        label={t('loading')}
                                                    />
                                                )}
                                            </div>
                                            <div>
                                                <Button
                                                    variant="quaternary"
                                                    label={t('previousPage')}
                                                    arrowDirection="left"
                                                    onClick={onPreviousPage}
                                                    disabled={
                                                        (tabs &&
                                                            tabs.length > 0 &&
                                                            tabs.findIndex(
                                                                (tab: {
                                                                    key: string;
                                                                }) =>
                                                                    tab.key ===
                                                                    activeTab,
                                                            ) === 0) ||
                                                        isUploadingFile
                                                    }
                                                    reversedArrow
                                                />
                                            </div>
                                        </div>
                                    </Form>
                                )}
                            </div>
                        </Formik>
                    </NavigationContent>
                </React.Fragment>
            )}
        </div>
    );
};

export default ClaimForm;
